var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 50,
    viewBox: "0 0 75 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.76 10.217C25.0589 6.72873 23.5213 3.5673 21.8267 0.0790585C22.9592 -0.00156282 24.0947 -0.0205437 25.229 0.0222115C28.2256 0.199821 31.726 0.732647 34.5786 1.10918C34.5786 1.10918 34.8731 1.81961 35.4423 3.06288C36.4303 5.19419 37.1565 6.79267 38.1968 8.92398C38.6069 9.7246 38.9697 10.5528 39.2829 11.4034C35.2853 11.034 30.496 10.5651 26.76 10.217C28.8275 14.4086 31.6475 19.2964 33.7935 23.6584C31.798 24.1415 30.0052 24.5038 28.2518 25.0154C26.7404 25.4558 23.6718 26.8838 22.1735 27.374C23.8616 30.9262 26.8582 37.9027 28.5593 41.4478C26.3413 42.9965 22.7885 46.2929 20.7079 48.069C20.3023 48.4171 19.9359 48.8363 19.3667 49.4118C18.3329 46.8968 17.4365 44.5808 16.4486 42.3074C12.174 32.4608 7.88188 22.6212 3.57236 12.7888C2.63674 10.6574 1.05993 7.15499 0 5.10183C2.49935 4.00065 6.81759 2.35244 9.37582 1.42177C10.8152 4.19247 14.0147 10.3093 15.3232 13.1511L17.5805 12.3696C19.5891 11.6592 21.6763 11.2258 23.7372 10.7214C24.6205 10.4798 25.53 10.3946 26.76 10.217Z",
    fill: "url(#paint0_linear_13443_1652)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7935 23.6371C37.6276 23.6371 41.743 23.7579 45.8061 23.7579C43.3067 19.7084 41.3439 15.4316 39.2633 11.3821C42.5347 11.3821 45.8584 11.6307 49.1102 11.6307C47.8016 8.78898 45.8977 5.64887 44.6153 2.89948C45.2569 2.69111 45.9135 2.54139 46.5781 2.4519C49.3457 1.92618 50.5954 1.89065 53.8864 1.08786C54.8613 3.21916 56.9419 7.25445 58.0607 9.2863C57.4423 9.59521 56.8038 9.85404 56.1502 10.0607C55.1653 10.429 54.1544 10.7093 53.1275 10.899C52.29 11.0766 50.3271 11.3892 49.1102 11.6094C51.1908 15.7015 53.3892 19.7723 55.4959 23.9142C52.2245 23.9142 49.0906 23.7366 45.7864 23.7366C48.5933 28.9867 52.0872 34.8549 54.7697 39.8777C52.2704 39.5154 48.9597 38.9896 46.4604 38.6628C44.9555 38.4639 42.4365 38.4426 40.9382 38.2082C40.9382 38.2082 40.9382 38.2579 40.7092 37.8245C38.4323 33.4766 35.9788 28.0063 33.7739 23.6158L33.7935 23.6371Z",
    fill: "url(#paint1_linear_13443_1652)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5156 23.9355C57.9757 23.4027 63.4781 22.5786 65.598 21.655C65.598 21.655 66.2523 22.4578 67.5609 24.3973C69.8814 27.6974 72.3647 30.8588 75 33.8674C73.9468 34.7105 72.8405 35.4725 71.6894 36.1479C68.6535 37.7109 67.6001 37.8316 64.4923 39.1744C61.4499 34.251 59.3235 30.6491 56.4512 25.7613C56.0831 25.1887 55.7696 24.577 55.5156 23.9355Z",
    fill: "url(#paint2_linear_13443_1652)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13443_1652",
    x1: 37.5,
    y1: 3.51698e-8,
    x2: 36.7223,
    y2: 49.4341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466385,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13443_1652",
    x1: 37.5,
    y1: 3.51698e-8,
    x2: 36.7223,
    y2: 49.4341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466385,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13443_1652",
    x1: 37.5,
    y1: 3.51698e-8,
    x2: 36.7223,
    y2: 49.4341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466385,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828282"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.1f67731a6dbe47950aebb513c0b214a9.svg";
export { ForwardRef as ReactComponent };